// actions.js
import axios from 'axios';

// Action types
export const FETCH_DATA_REQUEST = 'FETCH_DATA_REQUEST';
export const FETCH_DASHBOARD_DATA_SUCCESS = 'FETCH_DASHBOARD_DATA_SUCCESS';
export const FETCH_DATA_FAILURE = 'FETCH_DATA_FAILURE';
export const FETCH_SUB_CATEGORY_DATA_SUCCESS = 'FETCH_SUB_CATEGORY_DATA_SUCCESS';
export const FETCH_SUPPLIER_DATA_SUCCESS = 'FETCH_SUPPLIER_DATA_SUCCESS';
export const FETCH_UNIT_DATA_SUCCESS = 'FETCH_UNIT_DATA_SUCCESS';
export const FETCH_CHARGE_NAME_DATA = 'FETCH_CHARGE_NAME_DATA';
export const FETCH_CHARGE_TYPE_DATA = 'FETCH_CHARGE_TYPE_DATA';
export const FETCH_CHARGING_PARAMETER_DATA = 'FETCH_CHARGING_PARAMETER_DATA';
export const FETCH_CHARGING_UNIT_DATA = 'FETCH_CHARGING_UNIT_DATA';
export const FETCH_RATE_TYPE_DATA = 'FETCH_RATE_TYPE_DATA';
export const FETCH_STATUS_DATA = 'FETCH_STATUS_DATA';
export const FETCH_SEARCH_DATA = 'FETCH_SEARCH_DATA';
export const FETCH_EDIT_SEARCH_DATA = 'FETCH_EDIT_SEARCH_DATA';
export const FETCH_DELETE_SEARCH_DATA = 'FETCH_DELETE_SEARCH_DATA';
export const FETCH_ALL_DROPDOWN_DATA = 'FETCH_ALL_DROPDOWN_DATA';
export const FETCH_ALL_PAYMENTANDBALANCE_GRAPH = "FETCH_ALL_PAYMENTANDBALANCE_GRAPH";
export const FETCH_ALL_USAGES_GRAPH = "FETCH_ALL_USAGES_GRAPH";
export const FETCH_ALL_DISCONNECTIONANDRECONNECTION_GRAPH = "FETCH_ALL_DISCONNECTIONANDRECONNECTION_GRAPH";
export const FETCH_ALL_NOTIFICATION_GRAPH ="FETCH_ALL_NOTIFICATION_GRAPH"

// Action creators
// export const fetchDataRequest = () => ({
//   type: FETCH_DATA_REQUEST
// });

export const fetchDashboardDataSuccess = (data) => ({
  type: FETCH_DASHBOARD_DATA_SUCCESS,
  payload: data
});

export const fetchSubCategorySuccess = (data) => ({
  type: FETCH_SUB_CATEGORY_DATA_SUCCESS,
  payload: data
});

export const fetchSupplierCategorySuccess = (data) => ({
  type: FETCH_SUPPLIER_DATA_SUCCESS,
  payload: data
});
export const fetchUnitCategorySuccess = (data) => ({
  type: FETCH_UNIT_DATA_SUCCESS,
  payload: data
});

export const fetchChargingNameCategorySuccess = (data) => ({
  type: FETCH_CHARGE_NAME_DATA,
  payload: data
});

export const fetchChargingTypeCategorySuccess = (data) => ({
  type: FETCH_CHARGE_TYPE_DATA,
  payload: data
});

export const fetchChargingParameterCategorySuccess = (data) => ({
  type: FETCH_CHARGING_PARAMETER_DATA,
  payload: data
});

export const fetchChargingUnitCategorySuccess = (data) => ({
  type: FETCH_CHARGING_UNIT_DATA,
  payload: data
});
export const fetchRateTypeCategorySuccess = (data) => ({
  type: FETCH_RATE_TYPE_DATA,
  payload: data
});

export const fetchStatusDataSuccess = (data) => ({
  type: FETCH_STATUS_DATA,
  payload: data
});

export const fetchSearchDataSuccess = (data) => ({
  type: FETCH_SEARCH_DATA,
  payload: data
});

export const fetchEditSearchData = (data) => ({
  type: FETCH_EDIT_SEARCH_DATA,
  payload: data
});


export const fetchDeleteSearchData = (data) => ({
  type: FETCH_DELETE_SEARCH_DATA,
  payload: data
});

export const fetchAllDropDownDataSuccess = (data) => ({
  type: FETCH_ALL_DROPDOWN_DATA,
  payload: data
});


export const fetchPaymentAndBalanceGraph = (data) => ({
  type: FETCH_ALL_PAYMENTANDBALANCE_GRAPH,
  payload: data
});

export const fetchUsagesGraph = (data) => ({
  type: FETCH_ALL_USAGES_GRAPH, 
  payload: data
})

export const fetchDisconnectionAndReconnectionGraph = (data) => ({
  type: FETCH_ALL_DISCONNECTIONANDRECONNECTION_GRAPH, 
  payload: data
})

export const fetchNotificationGraph = (data) => ({
  type: FETCH_ALL_NOTIFICATION_GRAPH, 
  payload: data
})